import React, { useState, useContext, useEffect } from 'react'
import ModalLayout from '../Modals/ModalLayout';
import QuickUpModal from '../Modals/QuickUpModal';
import AutoComplete from './AutoComplete';
import TaskModal from '../Modals/TaskModal';
import LeadReplies from '../Modals/LeadReplies';
import { LeadsContext } from '../Context/LeadsContext';
import { useLocation } from 'react-router-dom';
import AppointmentModal from '../Modals/AppointmentModal';
import ModalLayoutNew from '../Modals/ModalLayoutNew';

const TopSection = ({handleNewAppraisal, tabClick}) => {
    const location = useLocation();
    const {leadData} = useContext(LeadsContext);

    const [taskCount,setTaskCount] = useState(0);
    const [replyCount,setReplyCount] = useState(0);
    const [appointmentCount,setAppointmentCount] = useState(0);
    const [noShows,setNoShows] = useState(0);

    const [quickOpen, setQuickOpen] = useState(false);
    const handleQuickUp = () => {
        setQuickOpen(true);
    }
    const quickClose = () => {
        setQuickOpen(false);
    }
    // Tasks Modal
    const [taskModal, setTaskModal] = useState(false);
    const handleTasksOpen = () => {
        setTaskModal(true);
        document.body.classList.add('overflow-body');
    }
    const handleTasksClose = () => {
        setTaskModal(false);
        document.body.classList.remove('overflow-body');
    }
    // Replies Modal
    const [repliesModal, setRepliesModal] = useState(false);
    const repliesModalOpen = (value) => {
        setRepliesModal(value);
    }
    // Appointments Modal
    const [appointmentModal, setAppointmentModal] = useState(false);
    const handleAppointmentsOpen = () => {
        setAppointmentModal(true);
    }
    const handleAppointmentsClose = () => {
        setAppointmentModal(false);
    }
    
    const customerQueueRoutes = ["/store", "/edit-announcements"];
    const topbarClass = customerQueueRoutes.some(route => location.pathname.includes(route))
    ? "topbar-block customer-side-page"
    : "topbar-block";
    return (
        <>
            <div className={topbarClass}>
                <div className='container-fluid'>
                    <div className='d-flex align-items-center justify-content-between topbar-btns'>
                        <div>
                            <button type="button" onClick={() => {repliesModalOpen(true)}} className='transparent-btn yellow-border d-inline-block me-3 text-uppercase'>
                                <span className='exclamation-icon'><i className="fa-solid fa-triangle-exclamation"></i></span> Un-Answered <span className='count ms-3'>{replyCount}</span>
                            </button>
                            <button type="button" onClick={handleTasksOpen} className='transparent-btn me-3 red-border d-inline-block'>
                                <span className='setting-icon'></span> TASKS <span className='count ms-3 text-red'>{taskCount}</span>
                            </button>
                            <button type="button" onClick={handleAppointmentsOpen} className='transparent-btn d-inline-block'>
                                <span className='user-delete-icon'></span> NO-SHOWS <span className='count ms-3'>{appointmentCount}</span>
                            </button>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='d-none d-lg-block'>
                                {/* {location.pathname !== '/auto-pilot' ? 
                                    <button className='blue-btn mnw-170 text-start' type='button' onClick={handleQuickUp}>
                                        <span className='upload-icon me-3'></span> QUICK UP
                                    </button> 
                                    :  */}
                                    <button className='blue-btn mnw-170 text-start' type='button' onClick={handleNewAppraisal}>
                                        <span className='upload-icon me-3'></span> New Appraisal
                                    </button>  
                                {/* } */}
                            </div>
                            {/* <div className='search-box position-relative ms-5'>
                                <input type='text' className='form-control' placeholder='Search' />
                                <span className='search-icon'><i className="fa-solid fa-magnifying-glass"></i></span>
                            </div> */}
                            <div className='d-none d-lg-block'><AutoComplete tabClick={tabClick}/></div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalLayout open={quickOpen} close={quickClose}>
                <QuickUpModal close={quickClose}/>
            </ModalLayout>
            <ModalLayoutNew open={taskModal} close={handleTasksClose}  darkThemeCls='true' modalWidth={990}>
                <TaskModal close={handleTasksClose} setTaskCount={setTaskCount}/>
            </ModalLayoutNew>
            <ModalLayout open={appointmentModal} close={handleAppointmentsClose}>
                <AppointmentModal close={handleAppointmentsClose} setAppointmentCount={setAppointmentCount}/>
            </ModalLayout>
            <ModalLayout open={repliesModal} close={() => {repliesModalOpen(false)}}>
                <LeadReplies close={() => {repliesModalOpen(false)}} setReplyCount={setReplyCount}/>
            </ModalLayout>
        </>
    )
}

export default TopSection